import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { GenericObservationDeviceLinkNoData } from 'health/observations/generics';
import { Insulin } from 'shared/fullColorIcons';

const typeDefinition = {
  type: ObservationType.Insulin,
  typeUnitMap: {
    [ObservationType.Insulin]: Unit.InternationalUnit
  },
  unitLabelMap: {
    [Unit.InternationalUnit]: local.units.internationalUnit
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.insulin,
  backPath: { to: routePaths.health },
  centerElement: local.observation.insulin.title,
  noDataText: local.observation.insulin.noDataText,
  iconSymbol: Insulin,
  renderNoDataComponent: (props) => props && <GenericObservationDeviceLinkNoData message={props.config.noDataText} />
};
